import { render, staticRenderFns } from "./ReviewTabs.vue?vue&type=template&id=0117c0eb&scoped=true&"
import script from "./ReviewTabs.vue?vue&type=script&lang=ts&"
export * from "./ReviewTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0117c0eb",
  null
  
)

export default component.exports